
export class SecureAnnouncementsPage {

    constructor() {

        //document.ready
        $(() => {


        });
    }

}